import React, { useEffect, useState } from "react";
import { Modal, Form, Input, InputNumber, Switch, Button, Select } from "antd";
import { ShowToast, Severty } from "../../helper/toast";
import callApi from "../../constants/API/CallApi";
import { getSubscription, updateSubscription } from "../../constants/API/API";
import useApi from "../../hooks/useApi";

const SubscriptionUpdate = ({
  editVisible,
  setEditVisible,
  selectedSubscription,
  refresh,
}) => {
  const [selectedSubscriptionRecord, setSelectedSubscriptionRecord] =
    useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const subscriptionId = selectedSubscription?._id;

  useApi({
    callback: getSubscription,
    payload: subscriptionId,
    dependencies: [subscriptionId],
    shouldCallApi: Boolean(subscriptionId),
    onSuccess: (data) => {
      setSelectedSubscriptionRecord(data);
    },
  });

  useEffect(() => {
    if (selectedSubscriptionRecord && editVisible) {
      form.setFieldsValue({
        name: selectedSubscriptionRecord.name || "",
        price: selectedSubscriptionRecord.price || 0,
        validity: selectedSubscriptionRecord.validity,
        description: selectedSubscriptionRecord.description || "", // Use lowercase 'description'
      });
    }
  }, [selectedSubscriptionRecord, editVisible, form]);

  const handleCancel = () => {
    setEditVisible(false);
    form.resetFields();
  };

  const handleOk = (values) => {
    if (!subscriptionId) return;

    setLoading(true);
    callApi({
      callback: updateSubscription,
      payload: [{ ...values }, subscriptionId], // Ensure description is included
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        setEditVisible(false);
        refresh(new Date().getTime());
        form.resetFields();
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const validateName = (_, value) => {
    if (!value) return Promise.reject("Please enter a subscription name");
    if (!/^[A-Z][a-zA-Z0-9 ]*$/.test(value)) {
      return Promise.reject(
        "Name must start with a capital letter and contain only letters, numbers, and spaces"
      );
    }
    return Promise.resolve();
  };

  // 🔒 Prevent rendering without valid data
  if (!editVisible || !subscriptionId) return null;

  return (
    <Modal
      open={editVisible}
      className="tab_modal"
      title="Update Subscription"
      onCancel={handleCancel}
      okButtonProps={{ htmlType: "submit", form: "edit-subscription", loading }}
      destroyOnClose
    >
      <Form
        id="edit-subscription"
        form={form}
        layout="vertical"
        onFinish={handleOk}
      >
        <Form.Item
          name="name"
          label="Subscription Name"
          rules={[{ required: true, validator: validateName }]}
        >
          <Input placeholder="Enter subscription name" />
        </Form.Item>

        <Form.Item
          name="price"
          label="Price (CAD)"
          rules={[{ required: true, message: "Please enter a price" }]}
        >
          <InputNumber
            min={0}
            style={{ width: "100%" }}
            placeholder="Enter price"
          />
        </Form.Item>

        <Form.Item
          name="validity"
          label="Validity Period"
          rules={[
            { required: true, message: "Please enter validity period" },
          ]}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Enter validity in months"
          >
            <Select.Option key={"month"}>1 Month</Select.Option>
            <Select.Option key={"year"}>1 Year</Select.Option>
          </Select>
        </Form.Item>

        {/* <Form.Item
          name="validity"
          label="Validity (in months)"
          rules={[{ required: true, message: "Please enter validity in months" }]}
        >
          <InputNumber
            min={1}
            style={{ width: "100%" }}
            placeholder="Enter validity"
          />
        </Form.Item> */}

        <Form.Item
          name="description" // Use lowercase 'description'
          label="Description"
          rules={[{ required: true, message: "Please enter a description" }]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Enter description"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SubscriptionUpdate;